import React from 'react';
import { View, StyleSheet, ViewStyle, StyleProp } from 'react-native';

// Define the types for the Divider component's props
interface DividerProps {
  color?: string;
  thickness?: number;
  orientation?: 'horizontal' | 'vertical';
  style?: ViewStyle;
}

const Divider: React.FC<DividerProps> = ({
    color = '#E0E0E0',
    thickness = 1,
    orientation = 'horizontal',
    style,
}) => {
    const dividerStyle: StyleProp<ViewStyle> = [
        styles.baseDivider,
        { backgroundColor: color },
        orientation === 'horizontal'
            ? { height: thickness, width: '100%' }
            : { width: thickness, height: '100%' },
        style,
    ];

    return <View style={dividerStyle} />;
};

const styles = StyleSheet.create({
    baseDivider: {
        alignSelf: 'center',
    },
});

export default Divider;
